import { ApplyToTrialButton } from '@components/app/Button/ApplyToTrial/index.client'
import { CriteriaMetTachometer } from '@components/app/EligibilityTachometer/CriteriaMetTachometer'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { type TrialAssociation } from '@modules/trials/types/TrialAssociation'

export const EligibilityCountCard = ({
  buttonColor = 'black',
  trial,
}: {
  buttonColor?: 'primary' | 'black'
  trial: TrialAssociation
}) => {
  return (
    <div className='grid grid-cols-1 gap-3'>
      <CriteriaMetTachometer trial={trial} />
      <ApplyToTrialButton
        color={buttonColor}
        source={TrackingSources.ELIGIBILITY_TACHOMETER_CARD}
        trial={trial}
      />
    </div>
  )
}
